export default __webpack_public_path__ + "static/media/trash.e84d0bb1.svg";